import axios from 'axios';
import enhanceError from './enhanceError';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API,
  timeout: 60000,
  headers: {
    PublicApi: 'yes',
  },
});

instance.interceptors.request.use(
  (config) => ({
    ...config,
    data: typeof config.data === 'object'
      ? Object.fromEntries(Object.entries(config.data).filter((e) => e[1] !== ''))
      : config.data,
  }),
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => Promise.resolve({ ...response, rejectException: () => enhanceError(response) }),
  async (error) => (
    (error.response !== undefined)
      ? Promise.resolve({ ...error.response, rejectException: () => enhanceError(error.response) })
      : Promise.reject(error)
  ),
);

export default instance;
